import React from "react";
import { CardHeader } from "@mui/material";

const DSCardHeader = (props: React.ComponentProps<typeof CardHeader>) => {
  return <CardHeader {...props} />;
};

export default DSCardHeader;
